var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        center: "",
        "append-to-body": "",
        visible: _vm.dialogVisible,
        width: "80%",
      },
      on: {
        close: _vm.close,
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("订单确认后变更")]),
      _c(
        "main",
        { attrs: { id: "main" } },
        [
          _c("div", { staticClass: "mainTitle" }, [
            _c("i", { staticClass: "el-icon-info icon1" }),
            _vm._v(" 变更说明"),
          ]),
          _c(
            "div",
            { staticClass: "table" },
            [
              _vm.tableData.length > 0
                ? _c("div", { staticClass: "tableLeft" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.resourceType.find(
                            (n) =>
                              n.code == _vm.tableData[0].orderChildren.state
                          ).name1
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    "header-cell-style": {
                      background: "#FBEFE8",
                      color: "#000",
                    },
                    data: _vm.tableData,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "useDate",
                      align: "center",
                      label: "使用日期",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productStockName",
                      align: "center",
                      label: "产品名称",
                      width: "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.orderChildren.resourceName
                                    ? scope.row.orderChildren.resourceName
                                    : scope.row.orderChildren.resourceNameEn
                                ) +
                                " (" +
                                _vm._s(scope.row.productStockName) +
                                ") "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productDesc",
                      align: "center",
                      label: "产品说明",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productNumber",
                      align: "center",
                      label: "己确认数量",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      prop: "address",
                      "class-name": "column",
                      align: "center",
                      label: "需要减少",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: {
                                size: "small",
                                min: scope.row.dwindleNumbersconst > 0 ? 1 : 0,
                                max: scope.row.productNumber,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.deleteNumClick(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.dwindleNumbersconst,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "dwindleNumbersconst",
                                    $$v
                                  )
                                },
                                expression: "scope.row.dwindleNumbersconst",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      prop: "address",
                      "class-name": "column",
                      align: "center",
                      label: "需要增加",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.productList,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  item.id
                                    ? _c("el-input-number", {
                                        attrs: {
                                          size: "small",
                                          min: 0,
                                          max: scope.row.productNumber,
                                        },
                                        model: {
                                          value: item.number,
                                          callback: function ($$v) {
                                            _vm.$set(item, "number", $$v)
                                          },
                                          expression: "item.number",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", align: "center", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#BF6642",
                                      "margin-right": "0.05rem",
                                    },
                                  },
                                  [_vm._v("其它产品")]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-circle-plus-outline",
                                  staticStyle: {
                                    color: "#BF6642",
                                    "font-size": "0.2rem",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addRoom(scope.row)
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "150",
                      prop: "address",
                      align: "center",
                      label: "选择产品",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.productList,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "lineBox" },
                                [
                                  !item.id
                                    ? _c(
                                        "div",
                                        { staticClass: "lineData" },
                                        [
                                          _vm.orderTypeList.includes(
                                            scope.row.orderChildren.orderType
                                          )
                                            ? _c("budgetProductFuzzySearch", {
                                                attrs: {
                                                  isFilter: true,
                                                  filterName:
                                                    scope.row.productStockName,
                                                  state:
                                                    scope.row.orderChildren
                                                      .state,
                                                  keys: "productNameCn",
                                                  data: item,
                                                },
                                              })
                                            : _c("basicProductFuzzySearch", {
                                                attrs: {
                                                  isFilter: true,
                                                  filterName:
                                                    scope.row.productStockName,
                                                  rid: scope.row.orderChildren
                                                    .resourceId,
                                                  state:
                                                    scope.row.orderChildren
                                                      .state,
                                                  keys: "productNameCn",
                                                  data: item,
                                                },
                                              }),
                                          scope.row.productList.length > 1
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-circle-close",
                                                staticStyle: {
                                                  "font-size": "0.3rem",
                                                  "margin-left": "0.05rem",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteRoom(
                                                      scope.row.productList,
                                                      index
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      prop: "address",
                      align: "center",
                      "class-name": "column",
                      label: "需要增加",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.productList,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "lineBox" },
                                [
                                  !item.id
                                    ? _c("el-input-number", {
                                        attrs: {
                                          size: "small",
                                          min: 0,
                                          max: scope.row.productNumber,
                                        },
                                        model: {
                                          value: item.number,
                                          callback: function ($$v) {
                                            _vm.$set(item, "number", $$v)
                                          },
                                          expression: "item.number",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "describe" },
            [
              _c("p", { staticClass: "describeP1" }, [
                _vm._v("其他增加的需求："),
              ]),
              _c("el-input", {
                staticStyle: { width: "9rem" },
                attrs: { placeholder: "请输入内容" },
                model: {
                  value: _vm.remark,
                  callback: function ($$v) {
                    _vm.remark = $$v
                  },
                  expression: "remark",
                },
              }),
            ],
            1
          ),
          _c("el-divider"),
          _c("el-card", { staticClass: "box-card" }, [
            _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "box-card-left" }, [
                _c("p", { staticClass: "box-card-left-p1" }, [
                  _vm._v("基于您上述的调整，根据取消政策， "),
                  _c("span", [_vm._v("减少的项目")]),
                  _vm._v("费用变化明细如下："),
                ]),
                JSON.stringify(_vm.reducedRenderingData) !== "{}"
                  ? _c("div", { staticClass: "box-card-left-bottom" }, [
                      _c(
                        "div",
                        { staticClass: "box-card-left-bottom-right" },
                        [
                          _vm._l(
                            _vm.reducedRenderingData,
                            function (item, index) {
                              return _c(
                                "el-card",
                                { key: index, staticClass: "box-card" },
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { width: "1.3rem" } },
                                    [_vm._v(_vm._s(item.useDate))]
                                  ),
                                  _c("p", [
                                    _vm._v("己付 ¥" + _vm._s(item.amountPaid)),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "取消费用 ¥" + _vm._s(item.cancelFees)
                                    ),
                                  ]),
                                  _c(
                                    "p",
                                    { staticStyle: { width: "1.3rem" } },
                                    [
                                      _vm._v(
                                        "可退 ¥" + _vm._s(item.refundableAmount)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "box-card-right" },
                                    [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            item.cancellationPolicyDescription
                                          ),
                                        },
                                      }),
                                      _c(
                                        "el-link",
                                        { attrs: { type: "danger" } },
                                        [
                                          _vm._v(
                                            "取消费用不合理? 点击此处与商家沟通"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }
                          ),
                          _c(
                            "div",
                            { staticClass: "box-card-left-bottom-right-bottm" },
                            [
                              _c("p", { staticStyle: { width: "1.3rem" } }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "box-card-left-bottom-right-bottm-p1",
                                },
                                [_vm._v("预计十个工作日内退款")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "box-card-left-bottom-right-bottm-p2",
                                },
                                [
                                  _vm._v("可退款金额(共)： "),
                                  _c("span", [
                                    _vm._v(
                                      "¥" + _vm._s(_vm.totalRefundableAmount())
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("el-card", { staticClass: "box-card" }, [
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "box-card-left" },
                [
                  _c("p", { staticClass: "box-card-left-p1" }, [
                    _vm._v("基于您上述的调整，您需要"),
                    _c("span", [_vm._v("增加的项目")]),
                    _vm._v("为： "),
                  ]),
                  _vm._l(_vm.mergeOrder, function (item, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        { staticClass: "box-card-left-bottom" },
                        [
                          _c(
                            "div",
                            { staticClass: "box-card-left-bottom-left" },
                            [_vm._v(" " + _vm._s(item.useDate) + " ")]
                          ),
                          _vm._l(item.arr, function (item1, index1) {
                            return _c(
                              "div",
                              {
                                key: index1,
                                staticClass: "box-card-left-bottom-right",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "box-card-left-bottom-right-top",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "0.1rem",
                                            },
                                          },
                                          [_vm._v(_vm._s(item1.nameCn))]
                                        ),
                                        _vm._l(
                                          item1.productArr,
                                          function (item2, index2) {
                                            return _c(
                                              "div",
                                              {
                                                key: index2,
                                                staticStyle: {
                                                  "margin-right": "0.1rem",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#BF6642",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item2.productNameCn
                                                      ) + " "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  _vm._s(item2.number) +
                                                    _vm._s(item2.useTime) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ])
                  }),
                ],
                2
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { color: "#BF6642" },
              attrs: { size: "small" },
              on: { click: _vm.send },
            },
            [_vm._v("确认井发送需求")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }